import * as React from "react";
import { useMsal } from "@azure/msal-react";
import { googlePolicyRequest, loginRequest, urlConfig } from "../../config";
import { LoginSuccessBox, LoginSuccessResponse } from "./LoginSuccessResponse";
import { PaycurraBg, PyButton } from "../../components";
import { Link, useLocation } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { MenuIcon } from "../../assets/svg";
import logo from "../../assets/logo/logo-paycurra.png";
import GooglePlay from "../../assets/images/black-google-play.svg";
import AppleStore from "../../assets/images/black-apple-store.svg";
import { FaEnvelope } from "react-icons/fa6";
import { FcGoogle } from "react-icons/fc";

const B2CLogin = () => {
  const { pathname } = useLocation();
  const { instance, accounts, inProgress } = useMsal();

  // React.useEffect(() => {
  //   if (accounts && inProgress === InteractionStatus.None) {
  //     setTimeout(() => {
  //       handleLoginRedirect();
  //     }, 3000);
  //   }
  // }, [accounts, inProgress, pathname]);

  const handleLoginRedirect = async () => {
    localStorage.setItem("mode", "email");

    await instance
      .handleRedirectPromise()
      .then(async (res) => {
        const account = instance.getActiveAccount();
        if (!account) {
          await instance.loginRedirect(loginRequest as any);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleGoogleLogin = async () => {
    localStorage.setItem("mode", "google");
    
    await instance
      .handleRedirectPromise()
      .then(async (res) => {
        const account = instance.getActiveAccount();
        if (!account) {
          await instance.loginRedirect(googlePolicyRequest as any);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <PaycurraBg>
      {!accounts || accounts?.length < 1 && (
        <section className="w-full min-h-screen flex items-center justify-center">
          <section className="w-full flex justify-center items-center">
            <div className="bg-white rounded-2xl border border-py_black-100 p-6 py-16 lg:px-[100px] lg:py-[85px]">
              <p className="mb-6 text-py_black-950 text-[20px] font-bold">
                Login to continue
              </p>
              <div className="flex flex-col gap-4 w-[300px]">
                <PyButton variant="SecondaryOutline" click={handleGoogleLogin}>
                  <FcGoogle size={24} />
                  Login with Google
                </PyButton>

                <PyButton
                  variant="SecondaryOutline"
                  click={handleLoginRedirect}>
                  <FaEnvelope size={24} />
                  Login with Email
                </PyButton>
              </div>
            </div>
          </section>
        </section>
      )}

      {accounts && accounts.length >= 1 && (
        <div style={{ overflow: "hidden" }}>
          <LoginSuccessResponse />
        </div>
      )}
    </PaycurraBg>
  );
};

export default B2CLogin;
